// @flow
import Href from "../../models/href/Href";

import type { Location } from "react-router";

/**
 */
export const parseUrl = (
  href: string | Href,
): { path: string, querystring: null | string, hash: null | string } => {
  if (href instanceof Href) {
    return {
      path: href.path,
      querystring: href.querystring,
      hash: href.hash,
    };
  }

  let path = href;
  let hash = null;
  let querystring = null;
  if (href.includes("#")) {
    const hashSplit = href.split("#");
    path = hashSplit[0];
    hash = hashSplit[1];
  }
  if (href.includes("?")) {
    const qsSplit = path.split("?");
    path = qsSplit[0];
    querystring = qsSplit[1];
  }
  return {
    path,
    querystring,
    hash,
  };
};

/**
 */
export const filterParameters = (
  href: string | Href,
  allowedParameters?: Array<string>,
): Href => {
  if (!Array.isArray(allowedParameters)) {
    return new Href(href);
  }

  const url = parseUrl(href);
  let filteredUrl = url.path;
  if (url.querystring) {
    const searchParams = new URLSearchParams(url.querystring);
    const params = Array.from(searchParams.keys());
    for (const param of params) {
      if (!allowedParameters.includes(param)) {
        searchParams.delete(param);
      }
    }
    filteredUrl = filteredUrl + "?" + searchParams.toString();
  }
  if (url.hash) {
    filteredUrl = filteredUrl + "#" + url.hash;
  }

  if (href instanceof Href) {
    return new Href(filteredUrl, href.resourcetype, {
      origin: href.origin,
      contextPath: href.contextPath,
    });
  }

  return new Href(filteredUrl);
};

/**
 */
export const createHref = (
  context: string,
  dynamicPart: string | Href,
  entryDate?: ?ISO_DATE,
  location?: ?Location,
  allowedParameters?: Array<string>,
): Href => {
  let href = dynamicPart.toString();

  if (!href.startsWith(`/${context}/`)) {
    href = `/${context}/${href}`;
  }

  // $FlowIssue
  href = href.replaceAll("//", "/");

  if (location?.search && !href.includes("?")) {
    const search = location.search.startsWith("?")
      ? location.search.substring(1)
      : location.search;
    href = `${href}?${search}`;
  }

  const finalHref =
    dynamicPart instanceof Href
      ? filterParameters(
          new Href(href, dynamicPart.resourcetype, {
            origin: dynamicPart.origin,
            contextPath: dynamicPart.contextPath,
          }),
          allowedParameters,
        )
      : filterParameters(href, allowedParameters);

  if (entryDate) {
    finalHref.setParameter("entryDate", entryDate);
  } else {
    finalHref.removeParameter("entryDate");
  }

  return finalHref;
};
